import { combineReducers } from 'redux'

import users from './users'
import roles from '../../UserTypes/reducers/roles'

export default combineReducers({
  users,
  roles
})
